import { useCallback } from "react";

export const useScrollGameday = () => {
  const scrollToGameday = useCallback((matches) => {
    if (!matches) return;
    setTimeout(() => {
      function parseDate(dateString) {
        const parts = dateString.split(".");
        return new Date(parts[2], parts[1] - 1, parts[0]);
      }
      const now = new Date();
      let gameday
      for (let i = 0; i < matches.length; i++) {
        if (parseDate(matches[i].date) >= now) {
          gameday = matches[i].gameday;
          break;
        } else {
          gameday = matches[matches.length - 1].gameday;
        }
      }
      const container = document.getElementById("matches");
      const element = document.getElementById(gameday);

      if (!container || !element) return;

      const scrollTop = element.offsetTop - container.offsetTop;

      container.scrollTo({
        top: scrollTop,
        behavior: "instant",
      });
    }, 500);
  }, []);

  return { scrollToGameday };
};
